const escapeHtml = (value) => value.replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll("'", '&#039;');
const unsubscribePlaceholder = '{{unsubscribe_url}}';
// Encode attribute separators too, so recipient data cannot create markup even
// when a template author uses an unquoted HTML attribute.
const escapeRecipientHtml = (value) => escapeHtml(value).replace(/[\t\n\f\r =`]/g, (character) => `&#${character.charCodeAt(0)};`);
function hasTemplateUnsubscribeLink(html) {
    // Ignore inert markup and consume whole tags, including quoted attributes.
    // A placeholder in a comment, data-href, or another attribute is not a link.
    const markup = html.replace(/<!--[\s\S]*?(?:-->|$)/g, '')
        .replace(/<(script|style|textarea|title)\b[^>]*>[\s\S]*?(?:<\/\1\s*>|$)/gi, '');
    const tags = markup.match(/<[a-z][\w:-]*(?=[\s/>])(?:[^"'<>]|"[^"]*"|'[^']*')*>/gi) ?? [];
    return tags.some((tag) => {
        if (!/^<a(?=[\s>])/i.test(tag))
            return false;
        const attributes = tag.slice(2, -1).matchAll(/([^\s="'<>/]+)(?:\s*=\s*(?:"([^"]*)"|'([^']*)'|([^\s"'=<>`]+)))?/g);
        for (const attribute of attributes) {
            if (attribute[1].toLowerCase() === 'href')
                return (attribute[2] ?? attribute[3] ?? attribute[4]) === unsubscribePlaceholder;
        }
        return false;
    });
}
/** Used by both the subscriber preview and the sender. */
export function renderEmailContent(input) {
    const variables = {
        name: input.recipient?.name?.trim() || 'there',
        email: input.recipient?.email ?? '',
        unsubscribe_url: input.preferencesUrl
    };
    // A single pass keeps placeholder-looking recipient data literal.
    const personalize = (template, html = false) => template.replace(/\{\{(name|email|unsubscribe_url)\}\}/g, (_match, variable) => {
        const value = variables[variable];
        return html ? (variable === 'unsubscribe_url' ? escapeHtml(value) : escapeRecipientHtml(value)) : value;
    });
    // Replace the preheader emitted by earlier versions of the draft compiler.
    let html = input.html.replace(/<div\b[^>]*(?:data-mailway-preheader=["']true["']|style=["']display:none;max-height:0;overflow:hidden["'])[^>]*>[\s\S]*?<\/div>/gi, '');
    const hasCustomUnsubscribeLink = hasTemplateUnsubscribeLink(html);
    html = personalize(html, true);
    const preheader = input.preheader ? `<div data-mailway-preheader="true" style="display:none;max-height:0;overflow:hidden">${escapeHtml(personalize(input.preheader))}</div>` : '';
    html = /<body\b[^>]*>/i.test(html) ? html.replace(/<body\b[^>]*>/i, (match) => match + preheader) : preheader + html;
    const footer = `<p style="font-family:Arial,sans-serif;font-size:12px;color:#66756b;margin-top:32px">You received this because you subscribed. <a href="${escapeHtml(input.preferencesUrl)}">Manage preferences or unsubscribe</a>.</p>`;
    if (!hasCustomUnsubscribeLink)
        html = /<\/body>/i.test(html) ? html.replace(/<\/body>/i, () => `${footer}</body>`) : html + footer;
    const text = input.text.includes(unsubscribePlaceholder)
        ? personalize(input.text)
        : `${personalize(input.text)}\n\nManage preferences or unsubscribe: ${input.preferencesUrl}`;
    return { html, text, ...(input.subject === undefined ? {} : { subject: personalize(input.subject).replace(/[\r\n]/g, ' ') }) };
}
